import { Heading, Paragraph } from '@zillow/constellation-10';
import { compact } from 'lodash-es';
import type { Contact } from '../../../../../../models/rental-application';
import { getPhoneNumberScreenFormat } from '../../../../../../utils/formatters';

type Props = {
  title: string;
  contact: Contact;
  hasRelationship?: boolean;
  hasNotes?: boolean;
  hasBusinessAddress?: boolean;
};

export function ContactOverview({
  title,
  contact,
  hasRelationship = false,
  hasNotes = false,
  hasBusinessAddress = false,
}: Props) {
  const summary = compact([
    contact.name,
    contact.email,
    contact.phone && getPhoneNumberScreenFormat(contact.phone),
    hasRelationship && contact.relationship,
  ]).join(' · ');

  return (
    <>
      <Heading
        level={6}
        textStyle="body-lg-bold"
        css={{ marginTop: 'tighter', marginBottom: 'tighter', color: 'text.subtle' }}
      >
        {title}
      </Heading>
      {summary && <Paragraph>{summary}</Paragraph>}
      {hasNotes && contact.notes && <Paragraph>{contact.notes}</Paragraph>}
      {hasBusinessAddress && contact.businessAddress && <Paragraph>{contact.businessAddress}</Paragraph>}
    </>
  );
}
